import PlaceholderDeck from '~/assets/images/deck-placeholder.jpg'
import type { Slide, SlideType, ThreeDSlide } from '~/entities/deck'
import type { DeepReadonly } from 'vue'

type thumbnailSlideTypes = Extract<SlideType, 'S' | 'M' | 'P' | 'V' | 'I'>
export function getSlideThumbnail(slide: Slide | DeepReadonly<Slide>): string {
  const thumbnailMap: Record<thumbnailSlideTypes, string | undefined> = {
    S: slide.preview?.url,
    M: (slide as ThreeDSlide).model_camera?.preview,
    // API returns a fallback thumb if there is no preview, this overrides that behavior without a substring check
    P: (slide.preview?.page_number != null && slide.preview?.url) || slide.image?.url,
    V: slide.file?.thumbnail,
    I: slide.file?.thumbnail,
  }
  return thumbnailMap[slide.type as thumbnailSlideTypes] || PlaceholderDeck
}
